export default __webpack_public_path__ + "static/media/watermeloncooler-wide@3x.b0208db2.jpg";